<h4 class="font-weight-bold py-3 mb-4">{{vacancy.shortDescription}}</h4>
<div class="card mb-4">
  <h6 class="card-header">
    Vacancy Details
  </h6>
  <div class="card-body">
    <form>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label class="form-label">Status</label>
          <div class="input-group">
            <input name="identifier" type="text" class="form-control" placeholder="Reference" [ngModel]="getReadableStatus(vacancy)" disabled>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label class="form-label">Deadline</label>
          <input name="asd" type="text" class="form-control" placeholder="Reference" [ngModel]="vacancy.deadline | date:'shortDate'" disabled>
        </div>
<!--        <div class="form-group col-md-4">-->
<!--          <label class="form-label">Issuer</label>-->
<!--          <input name="issuer" type="text" class="form-control" placeholder="Reference" [ngModel]="certificate.issuer" disabled>-->
<!--        </div>-->
      </div>
<!--      <div class="form-group">-->
<!--        <label class="form-label">Description</label>-->
<!--        <input name="description" type="text" class="form-control" placeholder="Description" [ngModel]="certificate.description" disabled>-->
<!--      </div>-->
<!--      <div class="form-group" *ngIf="certificate.isEligibleForApprovalBy(currentUser())">-->
<!--        <button class="btn btn-success" [swal]="swalApprove" (confirm)="approve(certificate); successDialog.fire()">Approve</button>-->
<!--        <button class="btn btn-danger" [swal]="swalReject" (confirm)="reject(certificate)">Reject</button>-->
<!--      </div>-->
<!--      <div class="form-group" *ngIf="!certificate.isEligibleForApprovalBy(currentUser())">-->
<!--        <label class="form-label">Status</label>-->
<!--        <span class="form-control cert" [ngClass]="certificate.cssStatus()">{{certificate.readableStatus()}}</span>-->
<!--      </div>-->
    </form>
  </div>
</div>

<div class="card mb-4">
  <h6 class="card-header">
    Candidates (3)
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <h5>Jan de Boer</h5>
      <h6>Certificates</h6>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Certificate</th>
          <th>Valid Until</th>
          <th>Required</th>
        </tr>
        </thead>
        <tbody>
        <tr style="background-color: #dfd">
          <td>Scrum Master I</td>
          <td>10/10/2022</td>
          <td>Yes</td>
        </tr>
        <tr>
          <td>Scrum Master II</td>
          <td>10/10/2022</td>
          <td>No</td>
        </tr>
        <tr>
          <td>WFT Basis</td>
          <td>10/10/2022</td>
          <td>No</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <h5>Henk Broekhuizen</h5>
      <h6>Certificates</h6>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Certificate</th>
          <th>Valid Until</th>
          <th>Required</th>
        </tr>
        </thead>
        <tbody>
        <tr style="background-color: #fdd">
          <td>Scrum Master I</td>
          <td>10/10/2019</td>
          <td>Yes</td>
        </tr>
        <tr>
          <td>WFT Basis</td>
          <td>10/10/2020</td>
          <td>No</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <h5>Klaas de Groot</h5>
      <h6>Certificates</h6>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Certificate</th>
          <th>Valid Until</th>
          <th>Required</th>
        </tr>
        </thead>
        <tbody>
        <tr style="background-color: #fdd">
          <td>Scrum Master I</td>
          <td>Not present</td>
          <td>Yes</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>


